import { collection, Timestamp, doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../config';
import { handleFirebaseError } from '../../error-handling';

export async function addMemberToOrganization(
  organizationId: string,
  userId: string,
  role: 'manager' | 'customer' | 'examiner' | 'instructor',
  addedBy: string
): Promise<boolean> {
  try {
    const memberId = `${organizationId}_${userId}_${role}`;
    const memberRef = doc(collection(db, 'organizationMembers'), memberId);
    const existing = await getDoc(memberRef);

    if (existing.exists()) {
      // Update role/addedBy without clobbering original addedAt
      await setDoc(
        memberRef,
        { role, addedBy },
        { merge: true }
      );
    } else {
      await setDoc(memberRef, {
        organizationId,
        userId,
        role,
        addedBy,
        addedAt: Timestamp.now()
      });
    }
    
    // Note: Organization default habits system has been removed
    // New customers will create their own personal habits
    
    return true;
  } catch (error) {
    handleFirebaseError(error, 'Error adding member to organization');
    return false;
  }
}